var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaqChromecast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.876 19.1255H20.126C16.3966 19.1255 13.376 22.1461 13.376 25.8755V36.0005H20.126V25.8755H80.876V73.1255H57.251V79.8755H80.876C84.6054 79.8755 87.626 76.8549 87.626 73.1255V25.8755C87.626 22.1461 84.6054 19.1255 80.876 19.1255ZM13.376 69.7505V79.8755H23.501C23.501 74.2899 18.9616 69.7505 13.376 69.7505ZM13.376 56.2505V63.0005C22.691 63.0005 30.251 70.5605 30.251 79.8755H37.001C37.001 66.8311 26.4204 56.2505 13.376 56.2505ZM13.376 42.7505V49.5005C30.1497 49.5005 43.751 63.1017 43.751 79.8755H50.501C50.501 59.3724 33.8791 42.7505 13.376 42.7505Z",
    fill: "#BCBCBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqChromecast);
export default __webpack_public_path__ + "static/media/faq-chromecast.40d87bc158d9fb97030c4fc4952152da.svg";
export { ForwardRef as ReactComponent };